<template>
  <div class="atsPage page">
    <div class="container">
      <search-template
        :search-title="pageData.content.title"
        :ats-query="pageData.content.key"
        list-name="Ats list"
        current-breadcrumb="Szukasz"
        route-name="ats-slug"
        route-pagination-name="ats-page-number"
        :json-description="pageData.content.contentJson"
      />
    </div>

    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapState, mapMutations } from 'vuex';
import SearchTemplate from '~/components/SearchTemplate';
import NewsletterHome from '~/components/Newsletter/NewsletterHome';

export default {
  name: 'AtsPage',
  components: {
    LazyHydrate,
    SearchTemplate,
    NewsletterHome,
  },
  nuxtI18n: {
    paths: {
      pl: '/szukaj/:slug',
      en: '/search-ats/:slug',
    },
  },
  async asyncData({ app, $config, error, $axios, route, redirect }) {
    try {
      const { data } = await $axios.get(
        `${$config.baseOfixApi}/e-commerce/v1/contents/ats/${route.params.slug}`,
        {
          useCache: true,
        },
      );

      // SSR cache: track this content so a cms_advice_ purge clears it.
      if (app.$cacheTracker && data.content) app.$cacheTracker.trackEntity('cms', data.content.id);
      return {
        pageData: data,
      };
    } catch (e) {
      error({
        statusCode: 404,
        message: e.response.data.message ? e.response.data.message : 'Page not found',
      });
    }
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  destroyed() {
    this.setAtsQuery({ type: 'search', value: null });
  },
  methods: {
    ...mapMutations({
      setAtsQuery: 'productsFilters/setAtsQuery',
    }),
  },
  head() {
    const followSlugs = [
      '/szukaj/hurtownia-papiernicza-opole',
      '/szukaj/zakupy-do-biura',
      '/szukaj/artykuly-papiernicze-radom',
      '/szukaj/artykuly-papiernicze-olsztyn',
      '/szukaj/artykuly-biurowe-wloclawek',
      '/szukaj/artykuly-papiernicze-rzeszow',
      '/szukaj/sklep-papierniczy-krakow',
      '/szukaj/miotla-z-szufelka',
      '/szukaj/sklep-papierniczy-kielce',
      '/szukaj/segregator-na-notatki',
      '/szukaj/bardzo-cichy-termowentylator',
      '/szukaj/hurtownia-papiernicza-opole',
      '/szukaj/hurtownia-papiernicza-czestochowa',
      '/szukaj/hurtownia-papiernicza-lodz',
      '/szukaj/wroclaw-sklep-papierniczy',
      '/szukaj/segregator-na-notatki',
      '/szukaj/hurtownia-papiernicza-lodz',
      '/szukaj/koperta-c6',
      '/szukaj/segregator-a5',
      '/szukaj/artykuly-biurowe-plock',
      '/szukaj/baterie-aaa',
      '/szukaj/sklep-papierniczy-zielona-gora',
      '/szukaj/artykuly-biurowe-bytom',
      '/szukaj/hurtownie-papiernicze-szczecin',
      '/szukaj/obwoluta-na-dokumenty',
    ];

    const isFollow = followSlugs.includes(this.$route.path);
    const schemaData = this.$helper.schemaData(this.pageData?.seo?.schemaOrgData ?? []);

    return {
      title: this.pageData?.seo?.title ?? this.pageData?.content?.seoTitle,
      meta: this.$helper.metaDescription([
        ...(this.pageData?.seo?.metaTags ?? []),
        !isFollow || Object.keys(this.$route.query).length
          ? {
              name: 'robots',
              content: 'noindex, nofollow',
            }
          : {
              name: 'robots',
              content: 'index, follow',
            },
      ]),
      script: [...schemaData],
      link: this.$helper.prevNextUrl(
        this.$route.query,
        this.pagination.offset,
        this.pagination.limit,
        this.pagination.countTotal,
        'ats-slug',
        'ats-page-number',
      ),
    };
  },
};
</script>
